import React, {useState} from 'react'
import {
  FloatingInputErrorStyle,
  FloatingInputWrapStyle,
  KP11LinkEmailInputStyle,
} from './kp-reusable-input-style'
import {errorWarningNotifyIcon, successNotifyIcon} from '../../../../assets'

export const FloatingInput = ({
  label,
  type = 'text',
  value,
  onChange,
  isValid = false,
  isError = false,
  helperText = '',
  loading = false,
  required = false,
  isDisabled = false,
  onBlur,
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const cardStatusStyle = isDisabled ? {opacity: 0.2} : {}

  return (
    <KP11LinkEmailInputStyle>
      <FloatingInputWrapStyle>
        <div className="floating-group">
          <input
            type={type}
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            style={cardStatusStyle}
            onFocus={() => setIsFocused(true)}
            onBlur={e => {
              setIsFocused(false)
              if (onBlur) onBlur(e)
            }}
            required={required}
            className={isError ? 'error' : ''}
          />
          <label className={isFocused || value ? 'floating' : ''}>
            {label}
          </label>
        </div>

        {isError && (
          <div className="floating-group-state-icon">
            <img src={errorWarningNotifyIcon} alt="error warning icon" />
          </div>
        )}

        {isValid && !isError && (
          <div className="floating-group-state-icon" style={cardStatusStyle}>
            <img src={successNotifyIcon} alt="success icon" />
          </div>
        )}
      </FloatingInputWrapStyle>

      <FloatingInputErrorStyle>
        {loading && !isError && !isValid && (
          <div className="helper-text-wrap">
            <div className="helper-text">Validating...</div>
          </div>
        )}

        {helperText && isError && (
          <div className="helper-text-wrap">
            <img src={errorWarningNotifyIcon} alt="error warning icon" />
            <div className="helper-text error">{helperText}</div>
          </div>
        )}
      </FloatingInputErrorStyle>
    </KP11LinkEmailInputStyle>
  )
}
